import { Component } from '@angular/core'

@Component({
  selector: 'app-icon',
  imports: [],
  template: '<ng-content/>',
  styleUrl: './icon.component.sass',
})
export class IconComponent {

}
